var map = {
	"./arrow_right.svg": 7962,
	"./auth_background.svg": 7442,
	"./calendar.svg": 8722,
	"./check_white.svg": 1518,
	"./file.svg": 1293,
	"./loading.svg": 4290,
	"./marker.svg": 6743,
	"./marker_orange.svg": 250,
	"./svg/icons/accountSettings.svg": 7114,
	"./svg/icons/add.svg": 1645,
	"./svg/icons/advertisements.svg": 5920,
	"./svg/icons/advertisements_active.svg": 4040,
	"./svg/icons/arrow_left.svg": 4651,
	"./svg/icons/arrow_right.svg": 8266,
	"./svg/icons/arrow_right_background.svg": 7831,
	"./svg/icons/arrow_right_blue.svg": 1736,
	"./svg/icons/back_black.svg": 5788,
	"./svg/icons/bell.svg": 3643,
	"./svg/icons/calendar.svg": 1421,
	"./svg/icons/caret_down.svg": 4951,
	"./svg/icons/caret_down_black.svg": 3534,
	"./svg/icons/caret_left.svg": 9737,
	"./svg/icons/caret_right.svg": 2991,
	"./svg/icons/check.svg": 4687,
	"./svg/icons/close.svg": 2479,
	"./svg/icons/cluster.svg": 394,
	"./svg/icons/dashboard.svg": 8554,
	"./svg/icons/delete.svg": 2474,
	"./svg/icons/desc.svg": 1538,
	"./svg/icons/download.svg": 7910,
	"./svg/icons/edit.svg": 9911,
	"./svg/icons/edit_new.svg": 497,
	"./svg/icons/editions.svg": 7426,
	"./svg/icons/editions_active.svg": 3893,
	"./svg/icons/error.svg": 7211,
	"./svg/icons/error_red.svg": 341,
	"./svg/icons/header_success.svg": 6814,
	"./svg/icons/home.svg": 1164,
	"./svg/icons/home_active.svg": 344,
	"./svg/icons/houses.svg": 6390,
	"./svg/icons/id.svg": 6250,
	"./svg/icons/image.svg": 4160,
	"./svg/icons/info.svg": 9932,
	"./svg/icons/info_white.svg": 8749,
	"./svg/icons/knowledge.svg": 4125,
	"./svg/icons/logo.svg": 1204,
	"./svg/icons/logout.svg": 230,
	"./svg/icons/logout_active.svg": 1329,
	"./svg/icons/maximize.svg": 7878,
	"./svg/icons/menu_burger.svg": 8665,
	"./svg/icons/message.svg": 5686,
	"./svg/icons/moon.svg": 6799,
	"./svg/icons/my_advertisements.svg": 587,
	"./svg/icons/my_advertisements_active.svg": 5132,
	"./svg/icons/myaccount.svg": 8706,
	"./svg/icons/myaccount_active.svg": 7232,
	"./svg/icons/netplan.svg": 9177,
	"./svg/icons/old_editions.svg": 6853,
	"./svg/icons/old_editions_active.svg": 1190,
	"./svg/icons/password.svg": 4134,
	"./svg/icons/print.svg": 5857,
	"./svg/icons/read.svg": 1766,
	"./svg/icons/rename.svg": 9696,
	"./svg/icons/search.svg": 2661,
	"./svg/icons/selectTriangle.svg": 5681,
	"./svg/icons/settings.svg": 3047,
	"./svg/icons/settings_active.svg": 3982,
	"./svg/icons/sort_dots.svg": 9067,
	"./svg/icons/statistics.svg": 9305,
	"./svg/icons/success.svg": 735,
	"./svg/icons/sun.svg": 5938,
	"./svg/icons/text.svg": 5987,
	"./svg/icons/ticket.svg": 7870,
	"./svg/icons/tickets.svg": 4549,
	"./svg/icons/times.svg": 2565,
	"./svg/icons/user.svg": 2327,
	"./svg/icons/users.svg": 8178,
	"./svg/icons/users_active.svg": 5871,
	"./svg/icons/warning.svg": 5561,
	"./svg/image_mark.svg": 9564,
	"./user.svg": 8497,
	"./user_light.svg": 5508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;